import { BusinessBadge } from "@/components/Brand";

const fmt = (n) => `${n.toLocaleString("fr-FR").replace(/\u202f/g, " ")} €`;
export const pricing = (price, saving = 0.2) => {
  const n = Number(price.replace(/\D/g, ""));
  const usual = Math.round(n / (1 - saving) / 10) * 10;
  return { usual: fmt(usual), saving: fmt(usual - n), pct: Math.round(((usual - n) / usual) * 100) };
};

const PriceBlock = ({ price, saving, testId }) => {
  const p = pricing(price, saving);
  return (
    <>
      <p data-testid={`${testId}-usual-price`} className="text-lg font-medium text-ivory/70 line-through decoration-gold decoration-2">{p.usual}</p>
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-3xl font-semibold text-ivory">{price}</p>
        <span data-testid={`${testId}-saving`} className="rounded-full bg-gold px-2.5 py-1 text-xs font-semibold text-navy-deep">
          -{p.pct} % · {p.saving} économisés
        </span>
      </div>
    </>
  );
};

export const OfferCard = ({ offer, testId }) => (
  <article
    data-testid={testId}
    className="group relative h-[340px] w-[250px] shrink-0 select-none overflow-hidden rounded-[28px] bg-navy-deep shadow-[0_20px_50px_-20px_rgba(5,10,30,0.7)] sm:h-[400px] sm:w-[300px]"
  >
    <img
      src={offer.image}
      alt={offer.city}
      draggable={false}
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-navy-deep via-navy-deep/30 to-transparent" />
    <div className="absolute left-4 top-4">
      <BusinessBadge />
    </div>
    <div className="absolute inset-x-0 bottom-0 p-5">
      <p className="font-display text-2xl text-ivory sm:text-[28px]">
        {offer.originCity} <span className="text-gold">⇄</span> {offer.city}
      </p>
      <div className="mt-3">
        <PriceBlock price={offer.price} saving={offer.saving} testId={testId} />
        <p className="text-[11px] text-ivory/60">aller-retour par personne</p>
      </div>
    </div>
  </article>
);
